import React                     from 'react';
import { useLocation }           from 'react-router-dom';
import { observer }              from 'mobx-react-lite';
import View                      from '@widesk-ui/components/View';
import useTheme                  from '@widesk-ui/hooks/useTheme';
import ClientRequestModel        from '@models/account/ClientRequestModel';
import clientRequestCounterStore from '@/stores/clientRequestCounterStore';

const ClientRequestNavigationLabel = observer(() => {
	const location = useLocation();
	const theme = useTheme();
	const isActive = location.pathname.startsWith(ClientRequestModel.pagePath('list'));
	const { submittedCount } = clientRequestCounterStore;

	React.useEffect(() => {
		clientRequestCounterStore.refresh().catch(() => undefined);
	}, [location.pathname]);

	return (
		<View row centerV spread gap="xs">
			<span>{ClientRequestModel.localize('plural')}</span>
			{submittedCount > 0 && (
				<span
					style={{
						boxSizing: 'border-box',
						display: 'inline-flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexShrink: 0,
						minWidth: 24,
						height: 24,
						marginRight: 4,
						padding: '0 6px',
						borderRadius: 999,
						background: isActive ? theme.colorTextLightSolid : theme.colorPrimary,
						boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
						color: isActive ? theme.colorPrimary : theme.colorTextLightSolid,
						fontSize: 11,
						fontWeight: 700,
						lineHeight: 1,
					}}
				>
					{submittedCount}
				</span>
			)}
		</View>
	);
});

export default ClientRequestNavigationLabel;
